import * as ramda from 'ramda';

// A helper function to reorder a list
export function reorder(list: any[], startIndex: number, endIndex: number) {
    const listWithout = ramda.remove(startIndex, 1, list);

    if (typeof list[startIndex] === 'undefined') return list;

    return ramda.insert(endIndex, list[startIndex], listWithout);
}
